<template>
  <button
    v-if="active"
    type="button"
    class="w-full bg-gray-100 flex items-center gap-2 rounded-full border border-gray-400 text-blue-600 text-xs md:text-sm font-medium px-3.5 py-1"
    @click="emit('clearAll')"
  >
    <RotateCwIcon size="14" />
    Reset Table
  </button>
</template>

<script setup>
import { RotateCwIcon } from 'lucide-vue-next'
const emit = defineEmits(['clearAll'])

const props = defineProps({
  active: {
    type: Boolean,
    required: true
  }
})
</script>
